import React, { useState } from "react";
import "../css/modal.css";
import { IoWarningOutline } from "react-icons/io5";
import EmailService from "../../modules/services/EmailService";

function ModalEmailIndividual({ isOpen, onClose, cliente, categoriaEmail, cdCategoriaEmail, onClienteUpdate }) {
    const [email, setEmail] = useState("");
    const [agree, setAgree] = useState(false);

    // Atualiza o email quando o modal abre ou quando o cliente muda
    React.useEffect(() => {
        if (isOpen && cliente && cdCategoriaEmail) {
            const emailEncontrado = cliente.emails.find(email => email.cdCategoriaEmail === cdCategoriaEmail);
            const emailAtual = emailEncontrado?.dsEmail || "";
            setEmail(emailAtual);
        }
    }, [isOpen, cliente, cdCategoriaEmail]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!agree) {
            alert("Você precisa concordar com os termos.");
            return;
        }

        try {
            const emailAtual = cliente?.emails.find(email => email.cdCategoriaEmail === cdCategoriaEmail)?.dsEmail;
            
            // Verifica se o email foi alterado
            if (email === emailAtual) {
                alert("Nenhuma alteração no e-mail.");
                return;
            }

            console.log('📧 Modal: Enviando dados para atualização:', {
                cdCliente: cliente.cdCliente,
                categoriaEmail: categoriaEmail.toLowerCase(),
                email: email,
                nmResponsavel: cliente.razaoSocial
            });
            console.log('📧 Modal: Email atual:', cliente.emails.find(email => email.cdCategoriaEmail === cdCategoriaEmail)?.dsEmail);
            console.log('📧 Modal: Novo email:', email);
            
            // Envia o email atualizado
            await EmailService.atualizarEmails(cliente.cdCliente, {
                [categoriaEmail.toLowerCase()]: email,
                nmResponsavel: cliente.razaoSocial,
            });

            alert("Email atualizado com sucesso!");
            console.log('📧 Email atualizado, chamando onClienteUpdate...');
            if (onClienteUpdate) {
                console.log('🔄 Chamando função de atualização...');
                await onClienteUpdate();
                console.log('✅ Função de atualização concluída');
            } else {
                console.log('⚠️ onClienteUpdate não foi passado para o modal');
            }
            // Aguarda um pouco antes de fechar o modal para garantir que a atualização foi processada
            setTimeout(() => {
                onClose();
            }, 500);
        } catch (error) {
            alert("Erro ao atualizar email.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <div className="topoModal">
                    <button className="modal-close" onClick={onClose}>✖</button>
                    <h3><b>Editar email {categoriaEmail}</b></h3>
                </div>
                <p>Digite o novo endereço de e-mail para {categoriaEmail.toLowerCase()}.</p>

                <label><b>E-mail {categoriaEmail.toLowerCase()}</b></label>
                <input
                    type="email"
                    placeholder="Digite o novo e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <div className="modal-alert">
                    <IoWarningOutline size={70} />
                    Caso você não confirme a alteração pelo link enviado ao novo e-mail, seu endereço de e-mail atual permanecerá o mesmo.
                </div>

                <p>O endereço eletrônico é de responsabilidade do informante.</p>

                <div className="modal-checkbox">
                    <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                    <label className="textoAceite">Estou ciente destas obrigações e concordo</label>
                </div>

                <div className="modal-actions">
                    <button className="cancel" onClick={onClose}>Cancelar</button>
                    <button 
                        className={`confirm ${!agree ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={!agree}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalEmailIndividual; 